import { colorSystem, Flexbox, Text, Tooltip } from '@luminovo/design-system';
import { InfoIcon } from 'lucide-react';
import type { JSX } from 'react';

/**
 * Displays a text with an information icon and tooltip.
 */
export const InfoLabel = ({
    label,
    info,
    textProps,
}: {
    label: string;
    info: string;
    textProps?: React.ComponentProps<typeof Text>;
}): JSX.Element => {
    return (
        <Flexbox
            gap={4}
            sx={{
                alignItems: 'center',
            }}
        >
            <Text {...textProps}>{label}</Text>
            <Tooltip title={info}>
                <InfoIcon size={20} color={colorSystem.neutral[6]} aria-hidden />
            </Tooltip>
        </Flexbox>
    );
};
